"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboboxOption = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("@headlessui/react");
const styles_1 = require("../../constants/styles");
const SelectedIcon_1 = require("../Dropdown/SelectedIcon");
const Option = (0, styled_1.default)(react_1.Combobox.Option)({
    margin: 0,
    outline: 'none',
});
const OptionContent = styled_1.default.div((props) => ({
    ...(0, styles_1.dropdownItemStyles)(props),
    alignItems: 'center',
    display: 'flex',
}));
const ComboboxOption = (props) => {
    return ((0, jsx_runtime_1.jsx)(Option, { value: props.value, children: ({ active, selected }) => ((0, jsx_runtime_1.jsxs)(OptionContent, { active: active && !props.placeholder, isPlaceholder: props.placeholder, small: props.small, children: [props.label, (0, jsx_runtime_1.jsx)(SelectedIcon_1.SelectedIcon, { selected: selected && !props.placeholder })] })) }));
};
exports.ComboboxOption = ComboboxOption;
